import React from 'react';
import Header from '../components/Header'
import {  Box} from '@chakra-ui/react';
import List from './price_other_channel/List'

const PriceOtherChannel = ()=>{
	return (
		<>
			<Header/>

			<Box>
				<List/>
			</Box>
		</>
		)
}

export default PriceOtherChannel